var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProvider",
    staticClass: "_eui-form_losenstyrka_validation-provider",
    attrs: {
      tag: "div",
      mode: "eagerMedBlurOchDebounce",
      rules: _vm.vpValidationRules
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var valid = ref.valid
          var errors = ref.errors
          var failedRules = ref.failedRules
          var flags = ref.flags
          return [
            _c(
              "div",
              {
                staticClass: "_eui-form_losenstyrka",
                class: {
                  "-readonly": _vm.vpReadOnly,
                  "-osynlig": _vm.skaVaraOsynlig,
                  "-invalid": flags.validated && !valid
                },
                attrs: { id: _vm.uniktId, title: _vm.vpTooltip }
              },
              [
                _vm.vpEtikettbreddMedEnhet !== "0"
                  ? _c("div", {
                      staticClass: "_eui-form_losenstyrka_etikett",
                      style: { "max-width": _vm.vpEtikettbreddMedEnhet }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "_eui-form_losenstyrka_rutyta",
                    style: { "max-width": _vm.vpRutbreddMedEnhet }
                  },
                  [
                    _vm.vpEtikettOvanfor
                      ? _c(
                          "p",
                          {
                            staticClass: "_eui-form_losenstyrka_etikett-ovanfor"
                          },
                          [
                            _c("eui-modifierad-svg", {
                              staticStyle: {
                                "stroke-width": "1.4",
                                width: "1.2em",
                                height: "1.2em",
                                "vertical-align": "-.17em",
                                "margin-right": "0.3em",
                                transform: "translateX(-1px)"
                              },
                              attrs: { "vp-ikon": "hjalpknapp" }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.vpEtikettOvanfor)
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.losenStyrkaCustomData.Styrka,
                          expression: "losenStyrkaCustomData.Styrka"
                        }
                      ],
                      ref: "inputelementet",
                      staticStyle: { display: "none !important" },
                      domProps: { value: _vm.losenStyrkaCustomData.Styrka },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.losenStyrkaCustomData,
                            "Styrka",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "_eui-form_losenstyrka_stapel",
                        style: { "max-width": _vm.vpStapelbreddMedEnhet },
                        attrs: { disabled: _vm.skaVaraInaktiverad }
                      },
                      _vm._l(_vm.stapelsteg, function(steg, stegIndex) {
                        var _obj
                        return _c("div", {
                          key: stegIndex,
                          staticClass: "_eui-form_losenstyrka_stapelsteg",
                          class:
                            ((_obj = {}),
                            (_obj[_vm.stapelstegFarg] = steg),
                            _obj),
                          style: {
                            width: _vm.stegBredd + "%"
                          },
                          attrs: { "steg-index": stegIndex }
                        })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !!_vm.losenStyrkaCustomData.StyrkaHtml,
                          expression: "!!losenStyrkaCustomData.StyrkaHtml"
                        }
                      ],
                      staticClass: "_eui-form_losenstyrka_beskrivning",
                      attrs: { disabled: _vm.skaVaraInaktiverad },
                      domProps: {
                        innerHTML: _vm._s(_vm.losenStyrkaCustomData.StyrkaHtml)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !!_vm.losenStyrkaCustomData.VarningHtml,
                          expression: "!!losenStyrkaCustomData.VarningHtml"
                        }
                      ],
                      staticClass: "_eui-form_losenstyrka_varning -rod-text",
                      attrs: { disabled: _vm.skaVaraInaktiverad },
                      domProps: {
                        innerHTML: _vm._s(_vm.losenStyrkaCustomData.VarningHtml)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !!_vm.losenStyrkaCustomData.ForslagHtml,
                          expression: "!!losenStyrkaCustomData.ForslagHtml"
                        }
                      ],
                      staticClass: "_eui-form_losenstyrka_forslag",
                      attrs: { disabled: _vm.skaVaraInaktiverad },
                      domProps: {
                        innerHTML: _vm._s(_vm.losenStyrkaCustomData.ForslagHtml)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "_eui-form_losenstyrka_feltext" },
                      [
                        _c("div", {
                          staticClass: "ellipsis",
                          domProps: { innerHTML: _vm._s(errors[0]) }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }